function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Groupe_3303",
  "data-name": "Groupe 3303",
  transform: "translate(-58 -294)"
}, React.createElement("g", {
  id: "Groupe_3220",
  "data-name": "Groupe 3220",
  transform: "translate(58 222)"
}, React.createElement("g", {
  id: "Groupe_3216",
  "data-name": "Groupe 3216",
  transform: "translate(88.469 174.438)"
}, React.createElement("rect", {
  id: "Rectangle_1712",
  "data-name": "Rectangle 1712",
  width: 28,
  height: 46,
  transform: "translate(37.531 9.656)",
  fill: "#867e88"
}), React.createElement("rect", {
  id: "Rectangle_1713",
  "data-name": "Rectangle 1713",
  width: 19,
  height: 37,
  transform: "translate(-0.469 18.656)",
  fill: "#867e88"
}), React.createElement("rect", {
  id: "Rectangle_1714",
  "data-name": "Rectangle 1714",
  width: 19,
  height: 56,
  transform: "translate(102.531 -0.344)",
  fill: "#867e88"
})), React.createElement("g", {
  id: "Groupe_3217",
  "data-name": "Groupe 3217",
  transform: "translate(23.281 155.813)"
}, React.createElement("path", {
  id: "Trac\\xE9_1872",
  "data-name": "Trac\\xE9 1872",
  d: "M77.25,290.5H40V220.656A4.656,4.656,0,0,1,44.656,216H72.594a4.656,4.656,0,0,1,4.656,4.656Z",
  transform: "translate(-40 -216)",
  fill: "#c9c6ca"
}), React.createElement("path", {
  id: "Trac\\xE9_1873",
  "data-name": "Trac\\xE9 1873",
  d: "M408,248v55.875h37.25V252.656A4.656,4.656,0,0,0,440.594,248Z",
  transform: "translate(-193.813 -229.375)",
  fill: "#c9c6ca"
})), React.createElement("g", {
  id: "Groupe_3218",
  "data-name": "Groupe 3218",
  transform: "translate(51.219 146.5)"
}, React.createElement("path", {
  id: "Trac\\xE9_1874",
  "data-name": "Trac\\xE9 1874",
  d: "M125.25,248v55.875H88V252.656A4.656,4.656,0,0,1,92.656,248Z",
  transform: "translate(-88 -220.063)",
  fill: "#9c969e"
}), React.createElement("path", {
  id: "Trac\\xE9_1875",
  "data-name": "Trac\\xE9 1875",
  d: "M176,252.656v51.219h27.938V252.656A4.656,4.656,0,0,0,199.281,248H180.656A4.656,4.656,0,0,0,176,252.656Z",
  transform: "translate(-124.781 -220.063)",
  fill: "#9c969e"
}), React.createElement("path", {
  id: "Trac\\xE9_1876",
  "data-name": "Trac\\xE9 1876",
  d: "M360,200v83.813h32.594V204.656A4.656,4.656,0,0,0,387.938,200Z",
  transform: "translate(-201.688 -200)",
  fill: "#9c969e"
})), React.createElement("path", {
  id: "Trac\\xE9_1877",
  "data-name": "Trac\\xE9 1877",
  d: "M256,236.656v60.531h46.563V236.656A4.656,4.656,0,0,0,297.906,232h-37.25A4.656,4.656,0,0,0,256,236.656Z",
  transform: "translate(-107 -66.875)",
  fill: "#c9c6ca"
}), React.createElement("path", {
  id: "Trac\\xE9_1878",
  "data-name": "Trac\\xE9 1878",
  d: "M293.344,345.313H4.656A4.656,4.656,0,0,1,0,340.656H0A4.656,4.656,0,0,1,4.656,336H293.344A4.656,4.656,0,0,1,298,340.656h0A4.656,4.656,0,0,1,293.344,345.313Z",
  transform: "translate(0 -110.344)",
  fill: "#dbd9dc"
}), React.createElement("path", {
  id: "Trac\\xE9_1879",
  "data-name": "Trac\\xE9 1879",
  d: "M260.406,72H157.969A13.969,13.969,0,0,0,144,85.969v186.25a13.969,13.969,0,0,0,13.969,13.969H260.406a13.969,13.969,0,0,0,13.969-13.969V85.969A13.969,13.969,0,0,0,260.406,72Zm4.656,172.281a4.656,4.656,0,0,1-4.656,4.656H157.969a4.656,4.656,0,0,1-4.656-4.656V113.906a4.656,4.656,0,0,1,4.656-4.656H260.406a4.656,4.656,0,0,1,4.656,4.656Z",
  transform: "translate(-60.188)",
  fill: "#6f6571"
}), React.createElement("g", {
  id: "Groupe_3219",
  "data-name": "Groupe 3219",
  transform: "translate(135.031 85.969)"
}, React.createElement("path", {
  id: "Trac\\xE9_1880",
  "data-name": "Trac\\xE9 1880",
  d: "M255.281,105.313H236.656a4.656,4.656,0,0,1,0-9.312h18.625a4.656,4.656,0,0,1,0,9.313Z",
  transform: "translate(-232 -96)",
  fill: "#5d5360"
}), React.createElement("ellipse", {
  id: "Ellipse_255",
  "data-name": "Ellipse 255",
  cx: 9,
  cy: 9.5,
  rx: 9,
  ry: 9.5,
  transform: "translate(4.969 172.125)",
  fill: "#5d5360"
})), React.createElement("path", {
  id: "Trac\\xE9_1881",
  "data-name": "Trac\\xE9 1881",
  d: "M162.625,272.219V248.938h-4.656a4.656,4.656,0,0,1-4.656-4.656V113.906a4.656,4.656,0,0,1,4.656-4.656h4.656V85.969A13.969,13.969,0,0,1,176.594,72H157.969A13.969,13.969,0,0,0,144,85.969v186.25a13.969,13.969,0,0,0,13.969,13.969h18.625A13.969,13.969,0,0,1,162.625,272.219Z",
  transform: "translate(-60.188)",
  fill: "#5d5360"
}), React.createElement("g", {
  id: "ADD-POINT",
  transform: "translate(101.097 121.919)"
}, React.createElement("path", {
  id: "Soustraction_1",
  "data-name": "Soustraction 1",
  d: "M189,197.823h0q-4.054-4.4-7.651-9.2a63.775,63.775,0,0,1-5.261-8.114c-1.587-3.006-2.391-5.51-2.391-7.442a15.141,15.141,0,0,1,1.206-5.947,15.317,15.317,0,0,1,28.226.015l0,.007a15.025,15.025,0,0,1,1.173,5.927c0,1.932-.8,4.436-2.391,7.442a63.784,63.784,0,0,1-5.261,8.109,119.545,119.545,0,0,1-7.651,9.2Zm.051-32.045a7.344,7.344,0,1,0,5.193,2.154A7.343,7.343,0,0,0,189.052,165.778Z",
  transform: "translate(-173.697 -157.766)",
  fill: "#d0263d"
}))), React.createElement("g", {
  id: "Groupe_1203",
  "data-name": "Groupe 1203",
  transform: "translate(194 388)"
}, React.createElement("ellipse", {
  id: "Ellipse_1",
  "data-name": "Ellipse 1",
  cx: 7.725,
  cy: 7.725,
  rx: 7.725,
  ry: 7.725,
  transform: "translate(5.518 5.518)",
  fill: "#2f7de1"
}), React.createElement("g", {
  id: "Ellipse_2",
  "data-name": "Ellipse 2",
  fill: "none",
  stroke: "#2f7de1",
  strokeWidth: 2
}, React.createElement("ellipse", {
  cx: 13.242,
  cy: 13.242,
  rx: 13.242,
  ry: 13.242,
  stroke: "none"
}), React.createElement("ellipse", {
  cx: 13.242,
  cy: 13.242,
  rx: 12.242,
  ry: 12.242,
  fill: "none"
}))));

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 298,
    height: 214.188,
    viewBox: "0 0 298 214.188",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.ec3d2155.svg";
export { ForwardRef as ReactComponent };